const binding = { modules: {}, dataActions: {} };

    (binding.modules['webgroup-search-controls'] = {
        c: () => require('partner/modules/webgroup-search-controls/webgroup-search-controls.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'webgroup-search-controls',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/webgroup-search-controls'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|webgroup-search-controls|webgroup-search-controls'] = {
                c: () => require('partner/modules/webgroup-search-controls/webgroup-search-controls.view.tsx'),
                cn: '__local__-__local__-webgroup-search-controls'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };